module.exports = __webpack_public_path__ + "6502d52ec4063015f6e750c9c51f882a.svg";